<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30" id="offerSkuList">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class="wd-lg-200">{{ $t("express.地址名称") }}</th>
            <th class="wd-lg-200">{{ $t("express.联系人") }}</th>
            <th class="wd-lg-250">{{ $t("express.省/市/区") }}</th>
            <th class="wd-lg-250">{{ $t("express.详细地址") }}</th>
            <th class="wd-lg-150">{{ $t("express.手机/电话") }}</th>
            <th class="wd-lg-100">
              {{ $t("express.默认") }}
              <i
                data-toggle="tooltip-primary"
                data-placement="top"
                :data-original-title="
                  $t('express.默认地址会用于您生成电子快递面单/退件地址等用途')
                "
                class="col-form-label ion-ios-help-outline tx-16 tx-info"
              ></i>
            </th>
            <th class="wd-lg-200">{{ $t("express.关联子账号") }}</th>
            <th class="wd-lg-100">{{ $t("express.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="valign-middle">
              <div class="tx-white">
                <p class="mg-b-5">
                  {{ item.name ? item.name : "---" }}
                </p>
              </div>
            </td>
            <td class="valign-middle">
              <div class="tx-white">
                <p class="mg-b-5">
                  {{ item.receiver }}
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="tx-ellipsis2 mg-b-0 tx-white">
                <p class="mg-b-5">
                  {{ item.province }}
                  <span v-if="item.city">/</span>
                  {{ item.city }}
                  <span v-if="item.area">/</span>
                  {{ item.area }}
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-0 tx-white">
                <p class="mg-b-5 tx-ellipsis2">
                  {{ item.address }}
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-0 tx-white">
                <p class="mg-b-5">
                  {{ $t("express.手机：")
                  }}{{ item.mobile ? item.mobile : "---" }}
                </p>
                <p class="mg-b-5 tx-ellipsis2">
                  {{ $t("express.固话：")
                  }}{{ item.telephone ? item.telephone : "---" }}
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-0 tx-white">
                <p class="mg-b-5">
                  {{
                    item.isDefault == 1 ? $t("express.是") : $t("express.否")
                  }}
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-0 tx-white">
                <p class="mg-b-5">
                  {{ item.subName ? item.subName : "---" }}
                </p>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-0 tx-white">
                <p
                  class="mg-b-5"
                  v-if="isSysRights('UserAddress.changeByUser')"
                >
                  <a
                    href="javascript:;"
                    class="tx-info"
                    @click="openModalAddAddress(index)"
                    >{{ $t("express.修改") }}</a
                  >
                </p>
                <p class="mg-b-5" v-if="isSysRights('UserAddress.delByUser')">
                  <a
                    href="javascript:;"
                    class="tx-danger"
                    @click="delAdd(index)"
                    >{{ $t("express.删除") }}</a
                  >
                </p>
                <p
                  class="mg-b-5"
                  v-if="
                    item.isDefault == 2 &&
                    isSysRights('UserAddress.changeByUser')
                  "
                  @click="setDef(index)"
                >
                  <a href="javascript:;" class="tx-info">{{
                    $t("express.设为默认")
                  }}</a>
                </p>
                <p
                  class="mg-b-0"
                  v-if="userInfo.supplierTransport == 1"
                  @click="relateSubuser(item)"
                >
                  <a href="javascript:;" class="tx-info">{{
                    $t("express.关联子账号")
                  }}</a>
                </p>
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="8">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("express.没有符合条件的地址") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      userInfo: store.get("userInfo"),
    };
  },
  watch: {},
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  methods: {
    relateSubuser(i) {
      this.$emit("relateSubuser", i);
    },
    setDef(i) {
      this.$emit("setDef", i);
    },
    delAdd(i) {
      this.$emit("delAdd", i);
    },
    openModalAddAddress(i) {
      this.$emit("openModalAddAddress", i);
    },
  },
};
</script>